<!-- <header>
    <div class="msg">
        <h1>welcome to RANI POKHARI PANCHAYAT<br>
        'Do Gaj Doori, Mask hai Jaruri!</h1>
        </div>    
<nav>
    <div class="logo">AMMA PANCHAYAT RANI POKHARI<BR>ଆମ ପଂଚାୟତ ରାଣୀ ପୋଖରୀ</div>
    <div class="menu">

        <ul><li><a href="">HOME</a></li>
            <li><a href="">About panchayat</a></li>
            <li><a href="">GALLERY</a></li>
            <li><a href="">contact</a></li>
        </ul>
    </div>
</nav>

</header> -->
<!-- Navigation -->

<header>
  <!-- As a link -->
  <div class="header__contener__top"></div>
  <nav class="navbar navbar-light bg-sucess justify-content-center" id="navi">
    <a class="navbar-brand waves-effect header_name" href="" target="_blank"
      >ଆମ ପଂଚାୟତ ଝାରପୋଖରିଆ
    </a>

    <!-- 
  <form class="form-inline my-2 my-lg-0 text-right ml-auto">
    <input class="form-control mr-sm-2" type="search" placeholder="Search" aria-label="Search">
    <button class="btn btn-outline-light my-2 my-sm-0" type="submit">Search</button>
  </form> -->
  </nav>
  <div class="header__contener__top"></div>
  <!-- Navbar -->

  <nav class="navbar navbar-expand-lg navbar-light white scrolling-navbar">
    <div class="container">
      <!-- Brand -->
      <!-- <a class="navbar-brand waves-effect" href="" target="_blank">ଆମ ପଂଚାୟତ ରାଣୀ ପୋଖରୀ
                </a> -->

      <!-- Collapse -->
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <!-- Links -->
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <!-- Left -->
        <ul class="navbar-nav mr-auto">
          <li class="nav-item">
            <a
              class="nav-link waves-effect rounded"
              [routerLink]="['Home']"
              routerLinkActive="active"
              >Home</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link waves-effect rounded"
              [routerLink]="['/About']"
              routerLinkActive="active"
              >About Panchayat</a
            >
          </li>

          <li class="nav-item">
            <a
              class="nav-link waves-effect rounded"
              [routerLink]="['/Team']"
              routerLinkActive="active"
              >PRI Members</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link waves-effect rounded"
              [routerLink]="['/Schemes']"
              routerLinkActive="active"
              >Schemes</a
            >
          </li>
          <!-- <li class="nav-item">
            <a
              class="nav-link waves-effect border border-light rounded"
              href=""
              target="_blank"
              >Schemes</a
            >
          </li> -->
          <!-- <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle waves-effect rounded"
              href="#"
              id="navbarDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Schemes
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
              <a
                class="dropdown-item text-success"
                href="https://www.spudart.org/etc/girl-baby-names/2017_baby_girl_names-complete_list_for_mobile_devices-32469_names.pdf"
                target="_blank"
                >PDS</a
              >
              <div class="dropdown-divider"></div>
              <a class="dropdown-item text-success" href="#">IGNOAPS</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item text-success" href="#">MPY</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item text-success" href="#">SBMS</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item text-success" href="#">MGNREGAS</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item text-success" href="#">IHHLS</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item text-success" href="#">HCSY</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item text-success" href="#">OSRGS</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item text-success" href="#">15th CFC Fund</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item text-success" href="#">5th SFC Fund</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item text-success" href="#"
                >Fishing with WSHG</a
              >
              <div class="dropdown-divider"></div>
              <a class="dropdown-item text-success" href="#"
                >WSHG Engaged in village Cleannes</a
              >
              <div class="dropdown-divider"></div>
              <a class="dropdown-item text-success" href="#">SPDWS</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item text-success" href="#"
                >PMAY Housing Scheme</a
              >
              <div class="dropdown-divider"></div>
              <a class="dropdown-item text-success" href="#"
                >AGY Housing Scheme</a
              >
              <div class="dropdown-divider"></div>
              <a class="dropdown-item text-success" href="#">Subhadra Yojana</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item text-success" href="#">Sub - Centre</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item text-success" href="#">AWC</a>
            </div>
          </li> -->

          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle waves-effec rounded"
              href="#"
              id="navbarDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Culture & Gallery
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
              <a
                class="dropdown-item text-success"
                [routerLink]="['/Culture']"
                routerLinkActive="active"
                >Culture</a
              >
              <div class="dropdown-divider"></div>
              <a
                class="dropdown-item text-success"
                [routerLink]="['/Gallery']"
                routerLinkActive="active"
                >Gallery</a
              >
            </div>
          </li>

          <li class="nav-item">
            <a
              class="nav-link waves-effect rounded"
              [routerLink]="['/Health']"
              routerLinkActive="active"
              >Health</a
            >
          </li>
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle waves-effect rounded"
              href="#"
              id="navbarDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Education
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
              <a
                class="dropdown-item text-success"
                [routerLink]="['/Schools']"
                routerLinkActive="active"
                >Schools</a
              >
              <div class="dropdown-divider"></div>
              <a class="dropdown-item text-success" href="#">Colleges</a>
            </div>
          </li>
        </ul>

        <!-- Right -->
        <ul class="navbar-nav nav-flex-icons">
          <!-- <li class="nav-item">
              <a href="https://www.facebook.com/mdbootstrap" class="nav-link waves-effect" target="_blank">
                <i class="fab fa-facebook-f"></i>
              </a>
            </li>  -->
          <!-- <li class="nav-item">
              <a href="https://twitter.com/MDBootstrap" class="nav-link waves-effect" target="_blank">
                <i class="fab fa-twitter"></i>
              </a>
            </li> -->

          <!-- <li class="nav-item">
              <a class="nav-link bg-primary waves-effect border border-light rounded"   [routerLink]="['/Complain-reg']" routerLinkActive="active">Complain Register <i class="bi bi-star-fill"></i></a>
            </li> -->
          <li class="nav-item">
            <a
              class="nav-link waves-effect rounded"
              href="https://rtionline.gov.in/"
              >RTI</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link waves-effect rounded"
              [routerLink]="['/Login']"
              routerLinkActive="active"
              >Login</a
            >
          </li>

          <!-- <li class="nav-item ">
              <a href="https://mdbootstrap.com/docs/jquery/newsletter/"
                class="nav-link border border-light rounded waves-effect mr-2" target="_blank">
                <i class="fas fa-envelope mr-1"></i>Newsletter
              </a>
            </li> -->
        </ul>
      </div>
    </div>
  </nav>
  <!-- Navbar -->

  <!-- Intro -->
  <div class="card card-intro blue-gradient">
    <div class="card-body white-text rgba-black-light text-center">
      <!--Grid row-->
      <div class="row d-flex justify-content-center">
        <!--Grid column-->
        <div class="col-md-6">
          <p class="h5 mb-2 text-uppercase">welcome to Jharpokharia</p>

          <p class="mb-0 font-weight-bold">दो गज की दुरी मास्क है जरुरी</p>
        </div>
        <!--Grid column-->
      </div>
      <!--Grid row-->
    </div>
  </div>
  <!-- Intro -->
</header>
<!-- Navigation -->
